/* eslint-disable tailwindcss/no-arbitrary-value */
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { EXCLUSIVE_REWARDS_TRANSLATIONS } from '../i18n';
import { BodyProps } from '../types';
import BrandUserInfo from './BrandUserInfo';
import RewardsInfo from './RewardsInfo';

const Body: React.FC<BodyProps> = ({
  product,
  singleGiftOffers,
  multipleGiftsOffers,
  isGiftOffersAvailable,
  carInsuranceQuotes,
  productWithLivePrice,
  carInsuranceSection,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(
    EXCLUSIVE_REWARDS_TRANSLATIONS,
    context,
  );

  return (
    <div className="bg-gray-200 flex flex-col grow md:flex-row md:items-start md:justify-evenly w-full px-3 md:px-0 xs:pb-3 md:pb-6 md:pt-3 sm:px-4">
      <div className="flex flex-col md:flex-row justify-center gap-4 lg:gap-6 w-full md:w-[720px] lg:w-[922px] -mt-10 md:-mt-15 sm:-mt-4">
        <RewardsInfo
          singleGiftOffers={singleGiftOffers}
          multipleGiftsOffers={multipleGiftsOffers}
          isGiftOffersAvailable={isGiftOffersAvailable}
        />
        <BrandUserInfo
          product={product}
          carInsuranceQuotes={carInsuranceQuotes}
          productWithLivePrice={productWithLivePrice}
          carInsuranceSection={carInsuranceSection}
        />
      </div>
      <span className="my-4 alpha-caption text-gray-700 md:hidden sm:block">
        {staticText.termsBy}{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-terms"
          target="_blank"
          rel="noreferrer"
          className="underline text-primary-800"
        >
          {staticText.termsAndConditions}
        </a>{' '}
        {staticText.and}{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="underline text-primary-800"
        >
          {staticText.privacyPolicyFooter}
        </a>
      </span>
    </div>
  );
};

export default Body;
